// `indigo` is a single colour in this Tailwind config, so its numbered shades generate nothing.
export const SCHEDULER_SELECT_CLASS =
  'border border-gray-300 rounded px-2 py-1.5 text-sm bg-white focus:outline-none focus:border-indigo disabled:bg-gray-50 disabled:text-gray-400';

export const SCHEDULER_LABEL_CLASS = 'block text-xs font-medium text-gray-600 mb-1';
